import { render, staticRenderFns } from "./custom-notifications.vue?vue&type=template&id=c71f6104&"
import script from "./custom-notifications.ts?vue&type=script&lang=ts&"
export * from "./custom-notifications.ts?vue&type=script&lang=ts&"
import style0 from "./custom-notifications.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports